var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('textarea',{staticClass:"form-control",attrs:{"id":_vm.id || _vm.action+_vm.name,"rows":_vm.rows,"placeholder":_vm.placeholder},domProps:{"value":_vm.model},on:{"input":function($event){return _vm.updateSelf($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }